<div class="button-toggle-bookmark">
  <div class="button-toggle-bookmark-inner">
    <ng-container *ngIf="showSpinner === false; else bookmarkSpiner">
      <!-- OFF -->
      <button
        *ngIf="!isBookmarked"
        class="button"
        mat-icon-button
        [disabled]="disabled"
        (click)="toggle()"
        matTooltip="お気に入りに登録します"
        matTooltipPosition="above"
      >
        <mat-icon class="icon" aria-hidden="false" aria-label="お気に入りに登録">star_border</mat-icon>
      </button>

      <!-- ON -->
      <button
        *ngIf="isBookmarked"
        class="button bookmarked"
        mat-icon-button
        [disabled]="disabled"
        (click)="toggle()"
        matTooltip="お気に入りを解除します"
        matTooltipPosition="above"
      >
        <mat-icon class="icon" aria-hidden="false" aria-label="お気に入りを解除">star</mat-icon>
      </button>
    </ng-container>
    <ng-template #bookmarkSpiner>
      <div class="progress-24">
        <mat-spinner [diameter]="24"></mat-spinner>
      </div>
    </ng-template>
  </div>
</div>
